/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();



document.addEventListener("DOMContentLoaded", () => {
  // Add event listener to the document to handle dynamically loaded content
  document.addEventListener("change", (event) => {
    // Check if the event target is a variant option button
    if (event.target.classList.contains("boost-pfs-product-item-default-swatch")) {
      const selectedVariant = event.target;

      // Find the closest product container
      const productContainer = selectedVariant.closest(".boost-pfs-filter-product-item");

      if (productContainer) {
        // Update the price
        const priceContainer = productContainer.querySelector(".boost-pfs-filter-product-item-sale-price");
        const variantPrice = selectedVariant.getAttribute("data-price");

        if (variantPrice && priceContainer) {
          priceContainer.textContent = variantPrice;
        }

        // Update the image
        // const imageContainer = productContainer.querySelector(".product-item__thumbnail figure img");
        // const variantImage = selectedVariant.getAttribute("data-image");

        // if (variantImage && imageContainer) {
        //   imageContainer.src = variantImage;
        //   imageContainer.srcset = variantImage;
        // }
      } else{
        const priceContainer = document.querySelector(".boost-pfs-filter-product-item-regular-price");
        const variantPrice = selectedVariant.getAttribute("data-price");
  
        // Update the price display
        if (variantPrice && priceContainer) {
          priceContainer.textContent = variantPrice;
        }

        // Update the image
        
        // const imageContainer = document.querySelector(".product-gallery__item figure img");
        // const variantImage = selectedVariant.getAttribute("data-image");

        // if (variantImage && imageContainer) {
        //   imageContainer.src = variantImage;
        //   imageContainer.srcset = variantImage;
        // }
      }
    }
  });
});